(() => {
  'use strict';

  const CLARITY_PROJECT_ID = 'xuhvhow043';
  const SCROLL_DEPTH_THRESHOLDS = [25, 50, 75, 100];

  // Queue events immediately so milestones reached before Clarity loads are kept.
  window.clarity =
    window.clarity ||
    function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

  function loadClarity() {
    const src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
    if (document.querySelector(`script[src="${src}"]`)) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  }

  function scheduleClarityLoad() {
    window.setTimeout(() => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(loadClarity, { timeout: 2000 });
      } else {
        loadClarity();
      }
    }, 5500);
  }

  if (document.readyState === 'complete') scheduleClarityLoad();
  else window.addEventListener('load', scheduleClarityLoad, { once: true });

  const reachedScrollDepths = new Set();
  let scrollFrame = 0;

  function measureScrollDepth() {
    scrollFrame = 0;
    const root = document.documentElement;
    const body = document.body;
    const documentHeight = Math.max(
      root ? root.scrollHeight : 0,
      root ? root.offsetHeight : 0,
      body ? body.scrollHeight : 0,
      body ? body.offsetHeight : 0,
    );
    if (!documentHeight) return;

    const scrollTop = Math.max(
      window.scrollY || 0,
      root ? root.scrollTop : 0,
      body ? body.scrollTop : 0,
    );
    const viewportHeight = Math.max(window.innerHeight || 0, root ? root.clientHeight : 0);
    const depth = Math.min(100, ((scrollTop + viewportHeight) / documentHeight) * 100);

    for (const threshold of SCROLL_DEPTH_THRESHOLDS) {
      if (depth < threshold || reachedScrollDepths.has(threshold)) continue;
      reachedScrollDepths.add(threshold);

      try {
        if (typeof window.clarity === 'function') {
          window.clarity('event', `scroll_depth_${threshold}`);
        }
      } catch {
        // Clarity must never break storefront behavior.
      }
    }
  }

  function scheduleScrollDepthMeasurement() {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(measureScrollDepth);
  }

  window.addEventListener('scroll', scheduleScrollDepthMeasurement, { passive: true });
  window.addEventListener('resize', scheduleScrollDepthMeasurement);
  window.addEventListener('pageshow', scheduleScrollDepthMeasurement);
  if (document.readyState === 'complete') scheduleScrollDepthMeasurement();
  else window.addEventListener('load', scheduleScrollDepthMeasurement, { once: true });
})();
